/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_N3Inputs */

const en_viewer_ref_n3 = /** @type {(inputs: Viewer_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labelled null rather than being shown as an empty value, so it cannot be mistaken for an empty string.`)
};

const ko_viewer_ref_n3 = /** @type {(inputs: Viewer_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빈 값으로 표시되지 않고 null로 이름이 붙으므로, 빈 문자열로 오해할 수 없습니다.`)
};

const ja_viewer_ref_n3 = /** @type {(inputs: Viewer_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空の値として表示されず null とラベル付けされるので、空文字列と間違えられません。`)
};

/**
* | output |
* | --- |
* | "Labelled null rather than being shown as an empty value, so it cannot be mistaken for an empty string." |
*
* @param {Viewer_Ref_N3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_n3 = /** @type {((inputs?: Viewer_Ref_N3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_N3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_n3(inputs)
	if (locale === "ko") return ko_viewer_ref_n3(inputs)
	return ja_viewer_ref_n3(inputs)
});